import TextField from '@mui/material/TextField';

const FromTextField = ({
  helperText = "",
  onChange = (event: any) => { onChange(event); }
}) => (
  <TextField id="tfZairyoNo"
    label="材料番号"
    size="small"
    inputProps={{ maxLength: 8 }}
    onChange={(event: any) => { onChange(event); }}
    error={!!helperText}
    helperText={helperText}
  />
);

export default FromTextField;